// extracted by mini-css-extract-plugin
export default {"wrapper":"Parcel__wrapper--3yL","icon":"Parcel__icon--eCs","wave":"Parcel__wave--3Bc","waves-animation":"Parcel__waves-animation--2uI"};